 import Popup from './Popup';

export default Popup;